import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    primary: {
      main: '#1976D2', // Example primary color
    },
    secondary: {
      main: '#FF5722', // Example secondary color
    },
    success: {
      main: '#3CA465', // Modify this to set your custom "success" color
    },
  },
});

export default theme;